import React, { useMemo } from 'react';
import { useAtomValue, useSetAtom } from 'jotai';
import { timelineRowsWithPreviewsAtom, timelineZoomAtom } from '../../atoms/frame-timeline-v4';
import { dispatchAtom } from '../../atoms/label-store-dispatch/dispatch';
import { EVENTS, UNDOABLE_EVENTS } from '../../atoms/label-store-dispatch/events';
import { timelineExpandedAnnotationIdsAtom } from '../../atoms/timeline-expansion-atoms';
import { CELL_WIDTH } from '../../constants/frame-timeline-v4';
import type { TimelineActionsT } from '../../types/frame-timeline-v4';
import { FrameTimeline } from './frame-timeline';
type PropsT = {
  totalFrames: number;
};
export const FrameTimelineContainer = ({
  totalFrames
}: PropsT) => {
  const rows = useAtomValue(timelineRowsWithPreviewsAtom);
  const zoom = useAtomValue(timelineZoomAtom);
  const toggleTimelineExpanded = useSetAtom(timelineExpandedAnnotationIdsAtom);
  const dispatch = useSetAtom(dispatchAtom);
  const cellWidth = CELL_WIDTH * zoom / 100;
  const timelineActions = useMemo<TimelineActionsT>(() => ({
    onToggleRowExpand: rowId => toggleTimelineExpanded(rowId),
    onSelectRow: rowId => dispatch({
      type: EVENTS.SELECT_ANNOTATION,
      annotationId: rowId
    }),
    onNavigateToFrame: frameIndex => dispatch({
      type: EVENTS.SET_CURRENT_FRAME,
      frameId: frameIndex
    }),
    onDeleteAnnotationSpan: params => dispatch({
      type: UNDOABLE_EVENTS.DELETE_ANNOTATION_FRAME_SPAN,
      ...params
    }),
    onUpdateAnnotationAttribute: params => dispatch({
      type: UNDOABLE_EVENTS.UPDATE_ANNOTATION_ATTRIBUTE,
      ...params
    }),
    onDeleteAnnotationAttribute: params => dispatch({
      type: UNDOABLE_EVENTS.DELETE_ANNOTATION_ATTRIBUTE,
      ...params
    })
  }), [dispatch, toggleTimelineExpanded]);
  return <FrameTimeline totalFrames={totalFrames} rows={rows} timelineActions={timelineActions} cellWidth={cellWidth} />;
};